'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdt';
var iconName = 'sparkles';
var width = 640;
var height = 512;
var aliases = [10024];
var unicode = 'f890';
var svgPathData = ['M55.4 256l111.1 49.4 5.6 2.5 2.5 5.6 49.4 111.1 49.4-111.1 2.5-5.6 5.6-2.5 111.1-49.4-111.1-49.4-5.6-2.5-2.5-5.6-49.4-111.1-49.4 111.1-2.5 5.6-5.6 2.5-111.1 49.4z', 'M536 8l0 64 64 0 0 16-64 0 0 64-16 0 0-64-64 0 0-16 64 0 0-64 16 0zM504 360l0 64 64 0 0 16-64 0 0 64-16 0 0-64-64 0 0-16 64 0 0-64 16 0zm-91.7-95.2L288 320 232.8 444.3 224 464 215.2 444.3 160 320 35.7 264.8 16 256 35.7 247.2 160 192 215.2 67.7 224 48 232.8 67.7 288 192 412.3 247.2 432 256 412.3 264.8zM273.4 313.5l2.5-5.6 5.6-2.5 111.1-49.4-111.1-49.4-5.6-2.5-2.5-5.6-49.4-111.1-49.4 111.1-2.5 5.6-5.6 2.5-111.1 49.4 111.1 49.4 5.6 2.5 2.5 5.6 49.4 111.1 49.4-111.1z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSparkles = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;